<template>
  <div>
    <b-card title="Número Lógico">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-logical-number-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :disabled="isSyncing"
        @click="onSync"
      >
        <feather-icon v-if="!isSyncing" icon="RefreshCwIcon" />
        <b-spinner v-if="isSyncing" small />
        {{ isSyncing ? 'Sincronizando...' :'Sincronizar' }}
      </b-button>
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        @click="reportData"
      >
        <feather-icon icon="FileTextIcon" />
        Exportar
      </b-button>
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="false"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BSpinner, BButton, BCard } from "bootstrap-vue";
// import CustomTable from "@/views/custom/table/CustomTable.vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import logicalNumberService from "@/providers/logicalNumberService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BButton,
    BCard,
    CustomGTable,
    BSpinner,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      isSyncing: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filterFields: [],
      filter: {},
      tableLoading: true,
      fields: [
        {
          field: "name",
          label: "Nome",
          sortable: true,
          filterOptions: {
            filterValue: '', 
            enabled: true,
            placeholder: "Pesquisar por nome",
            trigger: "enter",
          },
        },
        {
          field: "user_count",
          label: "Quantidade usuarios",
          sortable: true,
          filterOptions: {
            filterValue: '', 
            enabled: false,
            placeholder: "Pesquisar por nome",
            trigger: "enter",
          },
        },
        {
          field: "siga_nl_update",
          label: "NL Atualização",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '', 
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
        {
          field: "dt_update",
          label: "Data atualização sistema",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '', 
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Numero Lógico');
    this.setInitialTableFilters();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);
     
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    onSync() {
      this.isSyncing = true;
      messageDialogHelper.displayConfirmMessage(
        "Sincronização",
        "Gostaria de sincronizar os numeros logicos com sigaweb?",
        () => {
          
          const params = new URLSearchParams();
          logicalNumberService
            .sync(params)
            .then((response) => {
              this.isSyncing = false;
              console.log(response);
              messagesNotifyHelper.successNotify(
                "Sincronização Sigaweb",
                "Sincronização feita com sucesso"
              );

              this.loadData();
            })
            .catch((err) => {
              this.isSyncing = false;
              console.log(err);
            });
        }
      );
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      logicalNumberService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "usuario-logico.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onFilter(data) {
      // this.filter = data;
      // console.log("OnFilter: ", this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_LOGICAL_USER_REGISTER}/${data._id}`
      );
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onDelete(data) {
      console.log(data);
      const params = new URLSearchParams();
      logicalNumberService
        .deleteLogicalNumber(data._id, params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(() => {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', logicalNumberService.getAllLogicalNumber(this.searchParams))
        .then((res) => {
          // console.log(res);
          this.displayTable = true;
          this.totalRows = res.totalRows;
          this.data = res.data;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>